import { render, staticRenderFns } from "./msLiveTopic.vue?vue&type=template&id=e08a1ef8&scoped=true"
import script from "./msLiveTopic.vue?vue&type=script&lang=js"
export * from "./msLiveTopic.vue?vue&type=script&lang=js"
import style0 from "./msLiveTopic.vue?vue&type=style&index=0&id=e08a1ef8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e08a1ef8",
  null
  
)

export default component.exports